export default __webpack_public_path__ + "static/media/how-to-get-10k-instagram-followers.953a5721.md";